import { render, staticRenderFns } from "./housemaid-document-form.vue?vue&type=template&id=242db340&"
import script from "./housemaid-document-form.vue?vue&type=script&lang=js&"
export * from "./housemaid-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports